export { default as useProductsFilterCategories } from './useProductsFilterCategories';
